import { render, staticRenderFns } from "./PrimaryDistributions.vue?vue&type=template&id=2b9a0789&scoped=true"
import script from "./PrimaryDistributions.vue?vue&type=script&lang=js"
export * from "./PrimaryDistributions.vue?vue&type=script&lang=js"
import style0 from "./PrimaryDistributions.vue?vue&type=style&index=0&id=2b9a0789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a0789",
  null
  
)

export default component.exports